import React from 'react';
import Modal from './Modal';
import './css/Modal.css';

const SIGNUP_URL = 'https://www.busbarworld.com/signup';

const LoginPromptModal = ({ isOpen, onClose, onLogin }) => {
  const handleLogin = () => {
    onClose?.();
    onLogin?.();
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="로그인이 필요합니다"
      description="장바구니 추가 및 견적 요청을 위해 로그인이 필요합니다."
      showCloseButton
      titleAlign="left"
      footerAlign="right"
      footer={
        <>
          <button type="button" className="btn-cancel" onClick={handleLogin}>
            로그인
          </button>
          <a
            href={SIGNUP_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-confirm"
          >
            회원가입
          </a>
        </>
      }
    />
  );
};

export default LoginPromptModal;
